import { BaseResourceModel } from '../../models/base-resource.model';
import { Imovel } from './imovel.model';
import { DepreciacaoImovel } from './depreciacao-imovel.model';

export class DepreciacaoImovelItem extends BaseResourceModel {
  constructor(
    public id?: number,
    public valor_tombo_anterior?: number,
    public valor_depreciado?: number,
    public valor_depreciado_anterior?: number,
    public valor_residual?: number,
    public valor_avaliacao?: number,
    public vida_util?: number,
    public qtde_depreciada?: number,
    public qtde_depreciada_acumulada?: number,
    public status?: 'PENDENTE' | 'DEPRECIADO' | 'ERRO',
    public obs?: string,
    public imovel?: Imovel,
    public depreciacao?: DepreciacaoImovel,
  ) {
    super();
  }

  static converteJson(json: any): DepreciacaoImovelItem {
    return Object.assign(new DepreciacaoImovelItem(), json);
  }
}
